module.exports = __webpack_public_path__ + "static/media/Close_White.b71fbcd5.svg";